
















import Vue from 'vue';
import CustomerFilterSettings from '../../../../mass/components/mpgroup/CustomerFilterSettings.vue';

export default Vue.extend({
  components: {
    CustomerFilterSettings, 
  },
});
